import React from 'react';
import { Link } from 'react-router-dom';

// Reusable centered content section with optional eyebrow, title, description and CTA
export default function SectionBlock({
  eyebrow,
  title,
  description,
  ctaLabel,
  onCta,
  ctaHref,
  variant = 'light',
}) {
  const isDark = variant === 'dark';
  const ctaClass =
    'inline-block bg-[#b39869] hover:bg-[#9d8358] transition-colors duration-300 text-white uppercase tracking-[0.28em] text-xs px-10 py-4';
  return (
    <section
      className={`py-24 md:py-32 px-6 ${
        isDark ? 'bg-[#0b0b0b] text-white' : variant === 'gray' ? 'bg-[#eeeae4] text-[#1a1a1a]' : 'bg-white text-[#1a1a1a]'
      }`}
    >
      <div className="max-w-3xl mx-auto text-center">
        {eyebrow && (
          <div className="inline-block mb-6 pb-1 border-b border-[#b39869]">
            <span className="tracking-[0.35em] text-[11px] text-[#b39869] uppercase">{eyebrow}</span>
          </div>
        )}
        <h2
          className="text-4xl md:text-5xl mb-8 leading-tight"
          style={{ fontFamily: 'Playfair Display, serif', fontWeight: 400 }}
        >
          {title}
        </h2>
        {description && (
          typeof description === 'string' ? (
            <p className={`text-sm md:text-base leading-relaxed mb-10 ${isDark ? 'text-white/80' : 'text-[#444]'}`}>
              {description}
            </p>
          ) : (
            <div className={`text-sm md:text-base leading-relaxed mb-10 space-y-4 ${isDark ? 'text-white/80' : 'text-[#444]'}`}>
              {description}
            </div>
          )
        )}
        {ctaLabel && (
          ctaHref ? (
            <Link to={ctaHref} className={ctaClass}>{ctaLabel}</Link>
          ) : (
            <button onClick={onCta} className={ctaClass}>{ctaLabel}</button>
          )
        )}
      </div>
    </section>
  );
}
